'use strict';

exports.__esModule = true;
exports.getSurveyStartTexts = getSurveyStartTexts;
exports.getSkipButtonText = getSkipButtonText;
exports.getNextButtonText = getNextButtonText;
exports.getSubmitButtonText = getSubmitButtonText;
exports.getBackButtonText = getBackButtonText;
exports.getLanguageAbbreviation = getLanguageAbbreviation;
exports.checkDevice = checkDevice;
exports.getSurveyNameLength = getSurveyNameLength;
exports.getTextForLanguage = getTextForLanguage;
exports.fireGTMEvent = fireGTMEvent;
/* Survey start button text */
function getSurveyStartTexts() {
  return {
    en: 'Start Survey',
    es: 'Empezar Encuesta',
    de: 'Umfrage Starten',
    fr: 'Commencer l\'enquête',
    pt: 'Iniciar Pesquisa',
    zh: '开始调查',
    ko: '설문 조사 시작',
    vi: 'Bắt đầu cuộc điều tra',
    hi: 'सर्वेक्षण शुरू करें'
  };
}

function getSkipButtonText() {
  return {
    en: 'Skip',
    es: 'saltar',
    de: 'überspringen',
    fr: 'sauter',
    pt: 'pular',
    zh: '跳过',
    ko: '건너 뛰기',
    vi: 'Nhảy lớp',
    hi: 'छोड़ें'
  };
}

function getNextButtonText() {
  return {
    en: 'Next',
    es: 'próxima',
    de: 'nächste',
    fr: 'Prochain',
    pt: 'próxima',
    zh: '下一个',
    ko: '다음',
    vi: 'tiếp theo',
    hi: 'अगला'
  };
}

function getSubmitButtonText() {
  return {
    en: 'Submit',
    es: 'Enviar',
    de: 'Einreichen',
    fr: 'Soumettez',
    pt: 'Enviar',
    zh: '提交',
    ko: '제출하다',
    vi: 'đệ trình',
    hi: 'प्रस्तुत'
  };
}

function getBackButtonText() {
  return {
    en: 'Back',
    es: 'Espalda',
    de: 'zurück',
    fr: 'arrière',
    pt: 'De volta',
    zh: '背部',
    ko: '뒤',
    vi: 'Trở lại',
    hi: 'वापस'
  };
}

function getLanguageAbbreviation() {
  return {
    en: 'ENG',
    es: 'ESP',
    de: 'GER',
    fr: 'FRA',
    pt: 'POR',
    zh: 'MAN',
    ko: 'KOR',
    vi: 'VIE',
    hi: 'HIN'
  };
}

function checkDevice() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
}

function getSurveyNameLength(textObj, language) {
  var textLength = '';
  if (textObj[language]) {
    textLength = textObj[language].length;
  } else if (textObj.en) {
    textLength = textObj.en.length;
  }
  return textLength;
}

function getTextForLanguage(textObj, language) {
  var text = '';
  if (textObj[language]) {
    text = textObj[language];
  } else if (textObj.en) {
    text = textObj.en;
  }
  return text;
}

function fireGTMEvent(eventName, eventAction, eventLabel) {
  var dataLayer = [];
  if (typeof window.dataLayer !== 'undefined') {
    dataLayer = window.dataLayer;
  }
  var eventCategory = 'others';
  switch (eventName) {
    case 'page_load':
      eventCategory = 'page_load';
      break;
    case 'button_click':
    case 'search':
      eventCategory = 'button_click';
      break;
    case 'set_data':
      eventCategory = 'data_selection';
      break;
    default:
      eventCategory = 'others';
      break;
  }
  dataLayer.push({
    'event': eventName,
    'eventCategory': eventCategory,
    'eventAction': eventAction,
    'eventLabel': eventLabel
  });
}

exports.EVENT_PAGE_LOAD = 'page_load';
exports.EVENT_BTN_CLICK = 'button_click';
exports.EVENT_SET_DATA = 'set_data';
exports.EVENT_SEARCH = 'search';


//////////////////
// WEBPACK FOOTER
// ./src/utils/util-element.js
// module id = 91
// module chunks = 0